module.exports = __webpack_public_path__ + "static/media/scala.3c2e3606.svg";